import React, { ReactNode } from 'react';
import { DragSource, ConnectDragSource, DragSourceConnector, DragSourceMonitor, ConnectDragPreview } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
// Interfaces
import { IDragItem } from '../../interfaces/message.interfaces';

export interface IDragableProps {
    item: IDragItem;
    type: string;
    isDropped: boolean;
    onSelectedChange: (id: string, version: number, selected: boolean) => void;
    children: ReactNode;
    // Collected Props
    connectDragSource: ConnectDragSource;
    connectDragPreview: ConnectDragPreview;
    isDragging: boolean;
}

export class Dragable extends React.Component<IDragableProps> {
    public componentDidMount(): void {
        const { connectDragPreview } = this.props;
        if (connectDragPreview) {
            // Use empty image as a drag preview so browsers don't draw it
            // and we can draw whatever we want on the custom drag layer instead.
            connectDragPreview(getEmptyImage(), {
                // IE fallback: specify that we'd rather screenshot the node
                // when it already knows it's being dragged so we can hide it with CSS.
                captureDraggingState: true,
                offsetX: 1,
                offsetY: 1,
            });
        }
    }

    // A listitem or li must be a direct decendant of UL or OL to work with screen readers
    // this element should be a polymorph e.g. <Draggable as="li" />
    public render(): JSX.Element {
        return this.props.connectDragSource(<div role="listitem">{this.props.children}</div>);
    }
}

export default DragSource(
    (props: IDragableProps) => props.type,
    {
        beginDrag(props: IDragableProps) {
            const { item, type } = props;
            if (props.onSelectedChange) {
                props.onSelectedChange(item.documentId, item.version, true);
            }
            return { item, type };
        },
    },
    (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    })
)(Dragable);
